module.exports = __webpack_public_path__ + "img/epic-box.249925ea.png";